/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CameraResolutionType {
    Default = 0,
    StageDesigner = 1,
    RecordingWindow = 4,
    RecordingWindowFull = 7,
    /**
     * Will be displayed for the osce overview, which can have many cameras. CBU has more than 50 cameras displaying.
     */ 
    OsceRecordingWindowOverview = 10,
    OsceRecordingWindowDetail = 11,
    Recording = 3,
    Player = 2,
    PlayerFull = 8,
    StageDesignerSmall = 6,
    Thumbnail = 9,
}
